import { fg } from '@townsquare/stat-sig/gate';

export const isLabelledFeedResourceEnabled = (hasRovoWorkspace: boolean): boolean => {
	const isPopularTabsEnabled = fg('townsquare_enable_popular_tabs');
	return hasRovoWorkspace && isPopularTabsEnabled;
};
